/**
 * Controla el panel «Más» en móvil: anclado a la barra inferior
 * y con scroll para que un submenú abierto abajo muestre el ítem superior
 * (p. ej. «Por mes» en Análisis).
 */

export function resetScrollMenu(el) {
  if (!el) return 0;
  el.scrollTop = 0;
  return el.scrollTop;
}

/**
 * Desplaza el panel para que el bloque del submenú empiece visible
 * arriba del contenedor, no recortado por abajo.
 */
export function revelarSubmenuEnContenedor(itemEl, containerEl, padding = 8) {
  if (!itemEl || !containerEl) return 0;
  const maxScroll = Math.max(0, (containerEl.scrollHeight || 0) - (containerEl.clientHeight || 0));
  const itemRect = typeof itemEl.getBoundingClientRect === 'function'
    ? itemEl.getBoundingClientRect()
    : null;
  const boxRect = typeof containerEl.getBoundingClientRect === 'function'
    ? containerEl.getBoundingClientRect()
    : null;
  let next;
  if (itemRect && boxRect) {
    const delta = itemRect.top - boxRect.top - padding;
    next = (containerEl.scrollTop || 0) + delta;
  } else {
    const itemTop = typeof itemEl.offsetTop === 'number' ? itemEl.offsetTop : 0;
    next = itemTop - padding;
  }
  next = Math.min(Math.max(0, next), maxScroll);
  containerEl.scrollTop = next;
  return containerEl.scrollTop;
}

export function esViewportMovil(anchoPx) {
  return Number(anchoPx) < 992;
}
